import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { z } from 'zod';

import {
  setCurrentStudio,
  setToken,
  useCreateStudioAPI,
} from '~entities/studios';

const Component = () => {
  const navigate = Route.useNavigate();
  const { code } = Route.useSearch();

  const { data, isError, isFetching } = useCreateStudioAPI(code);

  useEffect(() => {
    if (data) {
      const token = data.token;
      setCurrentStudio(data.studio);
      setToken(token);
      void navigate({
        to: `/dashboard`,
        search: { id: data.studio.locationId },
      });
    }
  }, [data, navigate]);

  if (isError) {
    return (
      <div className='flex h-screen items-center justify-center'>
        Something went wrong ....
      </div>
    );
  }

  if (isFetching) {
    return (
      <div className='flex h-screen items-center justify-center'>
        Loading....
      </div>
    );
  }

  return null;
};

const authSearchParamSchema = z.object({ code: z.string() });

export const Route = createFileRoute('/authorize')({
  validateSearch: zodValidator(authSearchParamSchema),
  component: Component,
});
